import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import AppointmentDetails from '../AppointmentDetails';
import AppointmentApproved from '../AppointmentApproved';
import AppointmentCanceled from '../AppointmentCanceled';
import ConfirmationButtons from '../ConfirmationButtons';
import Map from '../GoogleMap';
import Notes from '../Notes';
import { ErrorHandler } from '../Errors/ErrorHandler';
import buttonsBackground from '../../images/buttons_bg.svg';
import AppointmentExpired from '../AppointmentExpired';
import Main from '../Main';

const AppointmentStatus = {
    New: 0,
    Confirmed: 2,
    Canceled: 99
}

const getNotes = (appointment) => {
    return appointment?.note?.length ? <Notes appointment={appointment} /> : null;
}

export const Reschedule = () => {
    const { id } = useParams();
    const [appointment, setAppointment] = useState(null);
    const [status, setStatus] = useState(200);
    const [disableReschedule, setDisableReschedule] = useState(false);
    const [blocking, setBlockingState] = useState(false);

    async function fetchAppointment() {
        axios.get('/rescheduleappointment/get?appointmentGuid=' + id + '&browserWidth=' + window.innerWidth)
            .then(response => {
                setAppointment(response.data);
                setStatus(response.status);
                setBlockingState(false);
            })
            .catch(error => {
                setStatus(error.response.status);
                setBlockingState(false);
            });
    }

    useEffect(() => {
        fetchAppointment();
    }, []);

    let notes = getNotes(appointment);
    let buttonsComponent;
    switch (appointment?.status) {
        case AppointmentStatus.Confirmed:
            let text = `תודה רבה, תור ${appointment.type} נקבע ל-${appointment.date} ב-${appointment.time}`;
            buttonsComponent = <AppointmentApproved text={text} />;
            break;
        case AppointmentStatus.Canceled:
            buttonsComponent = <AppointmentCanceled declinedText={appointment?.appointmentDeclinedText} />;
            break;
        case AppointmentStatus.New:
        default:
            buttonsComponent =
                <ConfirmationButtons
                    id={appointment?.id}
                    title={"האם לקבוע לך?"}
                    approveText={"תקבעו לי"}
                    disapproveText={"אל תקבעו"}
                    onClick={() => setBlockingState(true)}
                    callback={fetchAppointment}
                    method={"rescheduleappointment"}
                    checkboxText={appointment?.checkboxText}
                    checkboxVal={disableReschedule}
                    checkboxOnClick={() => setDisableReschedule(!disableReschedule)}
                />;
            break;
    }

    let content;

    if (appointment) {
        if (moment() > moment(appointment.pageExpiryDate, "YYYY-MM-DD HH:mm:ss")) {
            content =
                <Main appointment={appointment}>
                    <AppointmentExpired doctorName={appointment.doctorName} expiredText={appointment.appointmentExpiredText} />
                </Main>;
        } else {
            content =
                <Main blocking={blocking} appointment={appointment} title={"התפנה תור"}>
                    <AppointmentDetails appointment={appointment} />
                    <div className="container">
                        <div id="confirmation_buttons" className="d-flex justify-content-center align-items-center flex-column" style={{ backgroundImage: `url(${buttonsBackground})` }}>
                            {buttonsComponent}
                        </div>
                    </div>
                    {notes}
                    <Map appointmentId={appointment.id} address={appointment.clinicAddress} location={appointment.clinicLocation} />
                </Main>;
        }
    } else if (status !== 200) {
        content = <ErrorHandler status={status} />;
    } else {
        content = null;
    }

    return content;
}